import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const EcapTemplateService = {
    list: async () => axios.get(API_KEEPER + "/ecap-template/list").then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/ecap-template?id=" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (formData) => axios.post(API_KEEPER + "/ecap-template", formData).then(({data}) => data).catch((err) => { throw err }),

    update: async (formData) => axios.put(API_KEEPER + "/ecap-template", formData).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/ecap-template?id=" + id).catch((err) => { throw err }),

    options: async () => axios.get(API_KEEPER + "/ecap-template/options").then(({data}) => data).catch((err) => { throw err }),
};

export default EcapTemplateService;